import { mapFormData } from "./applicationSubmission";
import GmFinanceForm from "./gmFinanceForm";
import { buildLeadData } from "./leadSubmission";
const doWindow = window;
export default class FinancePrequal {
    constructor() {
        this.submitFormData = async (form) => {
            const data = mapFormData(form);
            try {
                const options = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                    },
                    body: JSON.stringify(data),
                };
                const response = await fetch(this._formSubmissionEndpoint, options);
                if (response.ok) {
                    this.sendLead(data, form);
                    return;
                }
                else if (response.status === 400) {
                    const errors = await response.json();
                    if (!errors["Unknown"]) {
                        this.showValidationErrorsAlert(errors);
                        form.SubmitBtn.removeAttribute("disabled");
                        return;
                    }
                    else {
                        throw new Error(`Form submission returned the following error message: ${errors.Unknown}`);
                    }
                }
                throw new Error(`Form submission returned an unexpected status code: ${response.status}.`);
            }
            catch (err) {
                console.error("An error occurred while submitting the GM Finance form.", err);
                alert("Sorry, something went wrong. Please try again or contact the dealership for assistance.");
                form.SubmitBtn.removeAttribute("disabled");
                return;
            }
        };
        this.sendLead = async (data, form) => {
            const formLeadData = buildLeadData(data);
            const leadData = {
                LeadType: 3,
                LeadSource: 26,
                ...formLeadData,
            };
            const endpoint = `/api/lead/save/${doWindow.DealeronLead.token.value}`;
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(leadData),
            };
            try {
                const response = await fetch(endpoint, options);
                if (!response.ok) {
                    throw new Error("Lead submission failed.");
                }
                const json = await response.json();
                // DealeronLeads does a bunch of stuff with events for tagging, so we have to duplicate it here
                form.dispatchEvent(new CustomEvent("leadSubmissionSuccess"));
                // DoTagging
                form.dispatchEvent(new CustomEvent("dotagging.event", {
                    bubbles: true,
                    detail: {
                        data: {
                            event: "lead_submitted",
                            submission_id: json.leadId,
                        },
                    },
                }));
                // OEM Tagging
                doWindow.TrackFormSubmission(json.leadId, leadData.LeadSource, json.leadSource, form);
                doWindow.DealeronLead.defaultSuccessCallback(json);
            }
            catch (err) {
                document.dispatchEvent(new CustomEvent("do-leads-submission-error", { detail: leadData }));
                console.error(err);
                window.location.href = "/thankyou.aspx?lid=-1";
            }
        };
        this.showValidationErrorsAlert = (errors) => {
            let msg = "Sorry, but GM Financial returned the following errors upon receiving this application:";
            for (const fieldName in errors) {
                msg += `\r\n${fieldName}: ${errors[fieldName]}.`;
            }
            alert(msg);
        };
        this._formSubmissionEndpoint = `/api/oemssaa/gm/submit-credit-app/${doWindow.DlronGlobal_DealerId}`;
        new GmFinanceForm(this.submitFormData);
    }
}
doWindow.DoUtility.SelfInstantiateOnLoad(FinancePrequal);
